module.exports = __webpack_public_path__ + "static/media/tip_text_cat_twelveweek_en.3a156d2d.svg";